import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import TextField from '@mui/material/TextField';
import { format } from 'date-fns';
 
// Rep l'ID, la data actual i la funció d'actualització
const TaskDueDate = ({ taskId, dueDate, onUpdateTaskDate }) => {
  
  // Si dueDate existeix, la parseja com a objecte Date
  const dateValue = dueDate ? new Date(dueDate) : null; 
 
  // La funció que s'executa en seleccionar una nova data
  const handleDateChange = (newDate) => {
    onUpdateTaskDate(taskId, newDate); 
  };
  
  return (
    <div style={{ marginLeft: '10px' }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label="Data Límit"
          value={dateValue}
          onChange={handleDateChange}
          renderInput={(params) => <TextField {...params} size="small" />} // Renderitzat amb TextField de MUI
        />
      </LocalizationProvider>
      {/* Opcionalment, mostrar la data formatada si no estem editant */}
      {dueDate && <p style={{ margin: '5px 0 0 0', fontSize: '0.85em', color: '#666' }}>Límit: {format(dateValue, 'dd/MM/yyyy')}</p>} 
    </div>
  );
};

export default TaskDueDate;
